import { CURRENCIES_BY_COUNTRY, DEFAULT_COUNTRY } from '../constants/country';
import type { Country } from '../types/country';

/** Free of moment so that it keeps time zone data out of client bundles: set the country with `setCurrentCountry` from `./country`. */
let currentCountry: Country | undefined;

export const getCurrentCountry = () => currentCountry || DEFAULT_COUNTRY;

export const getCurrentCurrency = () => CURRENCIES_BY_COUNTRY[getCurrentCountry()];

export const storeCurrentCountry = (country?: Country) => {
  currentCountry = country;
};
